import type { SurfaceProps } from './types';
import { surfaceFilled, DEFAULT_MOSCOW_COLS } from './types';

/** MoSCoW-style prioritisation board: assign pool items into columns (tap, no drag).
 *  Columns are configurable (config.columns) so the same board serves risk buckets
 *  (CRITICAL/IMPORTANT/MODERATE/LOW) etc. Default = Must/Should/Could/Won't. */
export function MoscowBoard({ spec, value, disabled, onChange }: SurfaceProps) {
  const pool = spec.config?.pool ?? [];
  const COLS = spec.config?.columns ?? DEFAULT_MOSCOW_COLS;

  const cols: Record<string, string[]> = {};
  for (const c of COLS) cols[c.key] = (value?.[c.key] as string[]) ?? [];
  const assigned = new Set<string>(Object.values(cols).flat());
  const unassigned = pool.filter((p) => !assigned.has(p));

  const move = (item: string, to: string | null) => {
    const next: Record<string, string[]> = {};
    for (const c of COLS) next[c.key] = (cols[c.key] ?? []).filter((x) => x !== item);
    if (to) next[to] = [...(next[to] ?? []), item];
    onChange(next, surfaceFilled(spec, next));
  };

  return (
    <div className="surf surf-moscow" data-testid="surf-moscow">
      <div className="surf-tag">Распредели задачи по категориям (нажми на букву)</div>
      {unassigned.length > 0 && (
        <div className="mos-pool">
          {unassigned.map((item) => (
            <div className="mos-item" key={item}>
              <span className="mos-nm">{item}</span>
              {!disabled && (
                <span className="mos-btns">
                  {COLS.map((c) => (
                    <button type="button" key={c.key} title={c.label}
                      onClick={() => move(item, c.key)}>{c.label[0]}</button>
                  ))}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
      <div className="mos-cols">
        {COLS.map((c) => (
          <div className={`mcol ${c.key}`} key={c.key}>
            <div className="ch">{c.label}</div>
            {(cols[c.key] ?? []).map((item) => (
              <span className="tok" key={item}>
                {item}
                {!disabled && (
                  <button type="button" className="rm" aria-label="вернуть"
                    onClick={() => move(item, null)}>×</button>
                )}
              </span>
            ))}
            {(cols[c.key] ?? []).length === 0 && <span className="mos-empty">—</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
